var render = function render(){var _vm=this,_c=_vm._self._c;return _c('insight',{attrs:{"insight":_vm.insight,"image-name":'first_cf_tips_header.svg',"button-text":'קדימה',"button-action":_vm.buttonAction},scopedSlots:_vm._u([{key:"insight-text",fn:function(){return [_c('div',[_vm._v("3 פעולות קטנות שאפשר לעשות כבר עכשיו כדי להיות על זה מהרגע הראשון!")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }